import "./index.scss";

const ColoredProgressBar = ({
  percentage = 0,
  barBackgroundColor = "#e0e0e0",
  barColor = "#005eb8",
}) => {
  return (
    <div
      className="progress-bar-container"
      style={{
        backgroundColor: percentage === 100 ? barColor : barBackgroundColor,
      }}
    >
      <div
        className="progress-bar-fill"
        style={{
          width: `${percentage}%`,
          backgroundColor: barColor,
          position: percentage === 100 ? "initial" : "absolute",
        }}
      />
    </div>
  );
};

export default ColoredProgressBar;
